import React from "react";
import { CheckCircleIcon, ClockIcon } from "@heroicons/react/24/outline";

export default function WhsSuccessCountdown({
  title,
  description,
  summaryCard,
  countdown,
  onReturn,
  buttonText = "Return to Job Attendance Now",
}) {
  return (
    <div className="text-center py-4 space-y-4 font-sans animate-in fade-in duration-300">
      <div className="text-emerald-500 mb-1">
        <CheckCircleIcon className="w-14 h-14 mx-auto animate-bounce text-emerald-500" />
      </div>

      <div className="space-y-1">
        <h2 className="text-lg font-bold text-slate-900 tracking-tight">{title}</h2>
        {description && (
          <p className="text-xs text-slate-500 max-w-sm mx-auto leading-relaxed">
            {description}
          </p>
        )}
      </div>

      {summaryCard}

      {/* Countdown Notification */}
      <div className="p-3 rounded-2xl bg-emerald-50/70 border border-emerald-200/70 text-emerald-800 text-xs font-semibold flex items-center justify-center gap-2">
        <ClockIcon className="w-4 h-4 text-emerald-600 shrink-0 animate-spin" />
        <span>
          Auto-redirecting back to Job Attendance in{" "}
          <strong className="text-emerald-900 text-sm font-black font-mono">
            {countdown}s
          </strong>
          ...
        </span>
      </div>

      <button
        type="button"
        onClick={onReturn}
        className="w-full bg-slate-900 hover:bg-slate-800 py-3 text-xs font-bold text-white rounded-xl shadow-md transition-all duration-200 cursor-pointer active:scale-[0.98]"
      >
        {buttonText}
      </button>
    </div>
  );
}
